import { Component, OnInit } from '@angular/core';
import { ParamMap, ActivatedRoute, Router } from '@angular/router';
import {  Observable } from 'rxjs';
import { AplicationStateService } from 'src/app/services/aplication-state.service';
import { TranslationService } from 'src/app/services/translation.service';
import { DataService } from 'src/app/services/data.service';


@Component({
  selector: 'app-products-by-category',
  templateUrl: './products-by-category.component.html',
  styleUrls: ['./products-by-category.component.css']
})
export class ProductsByCategoryComponent implements OnInit {

      public  mainCategorySlug: string;
      public lang: string;
      public menuCategoryDatas: Observable<any>;
      public avatarCategoryDatas: Observable<any>;
      public allProductsInMainCategory: any;
      public filteredProducts: Observable<any>;
      public activeFilters: any [] = [];
      public paginMaxLength: number;
      public pageSize: number;
      public pageSizeOption: number [];

  constructor(
      private appState: AplicationStateService,
      private rout: ActivatedRoute,
      private router: Router,
      public  tarnslator: TranslationService,
      private dataService: DataService
  ) {
      this.paginMaxLength = 0;
      this.pageSize = 10;
      this.pageSizeOption = [];
  }

  ngOnInit() {
          this.rout.paramMap.subscribe((params: ParamMap) => {
            this.mainCategorySlug = params.get('groupId');
            if(this.appState.filterHistory[0] != params.get('groupId')) {
              this.appState.filterHistory = [params.get('groupId')];
            }
            if (params.get('lang')) {
              this.appState.language = params.get('lang');
              this.lang = params.get('lang');
            }
            this.initComponentDatas();
          });
  }

  private initComponentDatas() {
    this.filteredProducts = null;
    if(this.appState.filterHistory.length == 0 )this.appState.filterHistory.push(this.mainCategorySlug);
    this.activeFilters.push(this.appState.filterHistory[this.appState.filterHistory.length-1]);
    this.dataService.getProductCount(this.activeFilters[this.activeFilters.length-1]).subscribe(data => {this.paginMaxLength = data; this.initPageSizeOption() });
    this.menuCategoryDatas = this.dataService.newGetCategorysByParentSlug(this.mainCategorySlug);
    this.avatarCategoryDatas = this.dataService.newGetCategorysByParentSlug(this.activeFilters[this.activeFilters.length-1]);
    this.filteredProducts = this.dataService.newGetProductsByCategorySlug(this.activeFilters[this.activeFilters.length-1], 0, this.pageSize);
  }

  changeCategory(category, name?, source?) {
    if(name) this.appState.categoryNameSlugMap.set(category, name);
    this.activeFilters = [category];
    this.dataService.getProductCount(category).subscribe(data => {this.paginMaxLength = data; this.initPageSizeOption() });
    let pos = this.appState.filterHistory.indexOf(category)
    console.log(this.appState.filterHistory)
    console.log(pos)
    if(source){
      this.appState.filterHistory = [this.mainCategorySlug, category];
    }else{
      if(pos != -1){
        this.appState.filterHistory = this.appState.filterHistory.slice(0, pos+1);
      }else{
        this.appState.filterHistory.push(category);
      }
    }
    this.avatarCategoryDatas = this.dataService.newGetCategorysByParentSlug(category);
    this.filteredProducts = this.dataService.newGetProductsByCategorySlug(category, 0, this.pageSize);
    if (this.appState.filterHistory[0] == 'szezonalis-termekek' && this.appState.filterHistory.length == 1) {
      this.filteredProducts = null;
    }
  }

  pageChanged(event) {
    this.filteredProducts = this.dataService.newGetProductsByCategorySlug(this.activeFilters[this.activeFilters.length-1], event.pageIndex * event.pageSize, this.pageSize);
  }

  openProduct(product) {
    if (this.lang) {
      this.router.navigate(['/' + this.lang + '/product/' + product.id]);
    } else {
      this.router.navigate(['product/' + product.id]);
    }
  }

  cancel() {
      let slug="";
      if(this.appState.filterHistory.length > 1){
        slug = this.appState.filterHistory[this.appState.filterHistory.length-2];
      }else
      {
        slug = this.mainCategorySlug;
      }
      this.changeCategory(slug);
  }

  initPageSizeOption() {
    const trunc = Math.trunc(this.paginMaxLength / this.pageSize);
    for (let i = 0; i < trunc; i++) {
      this.pageSizeOption.push(i * this.pageSize);
    }
  }

}




